import lazyScreen from '../utils/lazyScreen';
const OFTasks = lazyScreen(() => import('../pages/of/OFTasks/index.js'), 'pages/of/OFTasks/index.js');
const OFTask = lazyScreen(() => import('../pages/of/OFTask/index.js'), 'pages/of/OFTask/index.js');
const OFDailyReports = lazyScreen(() => import('../pages/of/OFDailyReports/index.js'), 'pages/of/OFDailyReports/index.js');
const OFDailyReport = lazyScreen(() => import('../pages/of/OFDailyReport/index.js'), 'pages/of/OFDailyReport/index.js');
const OFMeetingRooms = lazyScreen(() => import('../pages/of/OFMeetingRooms/index.js'), 'pages/of/OFMeetingRooms/index.js');
const OFMeetingRoom = lazyScreen(() => import('../pages/of/OFMeetingRoom/index.js'), 'pages/of/OFMeetingRoom/index.js');
const OFMeetings = lazyScreen(() => import('../pages/of/OFMeetings/index.js'), 'pages/of/OFMeetings/index.js');
const OFMeeting = lazyScreen(() => import('../pages/of/OFMeeting/index.js'), 'pages/of/OFMeeting/index.js');
const OFDocFolders = lazyScreen(() => import('../pages/of/OFDocFolders/index.js'), 'pages/of/OFDocFolders/index.js');
const OFDocFolder = lazyScreen(() => import('../pages/of/OFDocFolder/index.js'), 'pages/of/OFDocFolder/index.js');
const OFDocuments = lazyScreen(() => import('../pages/of/OFDocuments/index.js'), 'pages/of/OFDocuments/index.js');
const OFDocument = lazyScreen(() => import('../pages/of/OFDocument/index.js'), 'pages/of/OFDocument/index.js');
const OFBulletins = lazyScreen(() => import('../pages/of/OFBulletins/index.js'), 'pages/of/OFBulletins/index.js');
const OFBulletin = lazyScreen(() => import('../pages/of/OFBulletin/index.js'), 'pages/of/OFBulletin/index.js');
const OFObjectives = lazyScreen(() => import('../pages/of/OFObjectives/index.js'), 'pages/of/OFObjectives/index.js');
const OFObjective = lazyScreen(() => import('../pages/of/OFObjective/index.js'), 'pages/of/OFObjective/index.js');
const OFTeamDashboard = lazyScreen(() => import('../pages/of/OFTeamDashboard/index.js'), 'pages/of/OFTeamDashboard/index.js');

const OFApprovals = lazyScreen(() => import('../pages/wf/WFApprovalPendings/index.js'), 'pages/wf/WFApprovalPendings/index.js');
const OFApproval = lazyScreen(() => import('../pages/of/OFApproval/index.js'), 'pages/of/OFApproval/index.js');

export default [
    { path: '/of/OFApprovals', component: OFApprovals },
    { path: '/of/OFApproval/:code', component: OFApproval },
    { path: '/of/OFTasks', component: OFTasks },
    { path: '/of/OFTask/:code', component: OFTask },
    { path: '/of/OFDailyReports', component: OFDailyReports },
    { path: '/of/OFDailyReport/:code', component: OFDailyReport },
    { path: '/of/OFMeetingRooms', component: OFMeetingRooms },
    { path: '/of/OFMeetingRoom/:code', component: OFMeetingRoom },
    { path: '/of/OFMeetings', component: OFMeetings },
    { path: '/of/OFMeeting/:code', component: OFMeeting },
    { path: '/of/OFDocFolders', component: OFDocFolders },
    { path: '/of/OFDocFolder/:code', component: OFDocFolder },
    { path: '/of/OFDocuments', component: OFDocuments },
    { path: '/of/OFDocument/:code', component: OFDocument },
    { path: '/of/OFBulletins', component: OFBulletins },
    { path: '/of/OFBulletin/:code', component: OFBulletin },
    { path: '/of/OFObjectives', component: OFObjectives },
    { path: '/of/OFObjective/:code', component: OFObjective },
    { path: '/of/OFTeamDashboard', component: OFTeamDashboard }
];
